import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const VehicleEdit = ({ fetchVehicle, vehicle, onClose }) => {
  const [getBrands, setGetBrands] = useState([]);
  const [getFuelType, setGetFuelType] = useState([]);
  const [vehicleAdded, setVehicleAdded] = useState(false);

  const [checkBrandId, setCheckBrandId] = useState("");

  const [formData, setFormData] = useState({
    brand: "",
    model: "",
    make_year: "",
    fuel: "",
    vehicle_number: "",
  });

  const token = localStorage.getItem("customer-token");
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  useEffect(() => {
    const fetchBrands = async () => {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/brands/`
      );

      setGetBrands(response?.data);
    };
    fetchBrands();
  }, []);

  const [getModels, setGetModels] = useState([]);
  const [getAllModels, setGetAllModels] = useState([]);

  const handleInputChange = (field: any, value: any) => {
    // setCheckBrandId(value)
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleBrandChange = (e) => {
    const selectedBrandId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      brand: selectedBrandId,
      model: "", // Optional: Reset model when brand changes
    }));
    setCheckBrandId(selectedBrandId); // triggers useEffect
  };

  useEffect(() => {
    if (checkBrandId) {
      const fetchModels = async () => {
        const response = await axios.get(
          `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/models/?brand=${checkBrandId}`
        );

        setGetModels(response?.data);
      };
      fetchModels();
    }
  }, [checkBrandId]);

  useEffect(() => {
    const fetchModels = async () => {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/models/`
      );

      setGetAllModels(response?.data);
    };
    fetchModels();
  }, []);


  useEffect(() => {
    const fetchFuelType = async () => {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/inventory/fuel-types/`
      );
      setGetFuelType(response?.data);
    };
    fetchFuelType();
  }, []);

  const years = Array.from({ length: 25 }, (_, i) =>
    (new Date().getFullYear() - i).toString()
  );


 useEffect(() => {
  if (vehicle) {
    setFormData({
      brand: vehicle.brand,
      model: vehicle?.model,
      make_year: vehicle.make_year,
      fuel: vehicle?.fuel,
      vehicle_number: vehicle.vehicle_number,
    });

    // ✅ Set brand ID immediately when editing a vehicle
    setCheckBrandId(vehicle.brand);
  } else {
    setFormData({
      brand: "",
      model: "",
      make_year: "",
      fuel: "",
      vehicle_number: "",
    });

    // ✅ Reset models list if adding a new vehicle
    setCheckBrandId("");
  }
}, [vehicle]);

 const handleSave = async () => {
  if (
    !formData.brand ||
    !formData.model ||
    !formData.make_year ||
    !formData.fuel ||
    !formData.vehicle_number
  ) {
    toast.error("Please fill all required fields");
    return;
  }

   const patterns = [
    // Standard format: DL14CH2166 (2 letters + 2 digits + 2 letters + 4 digits)
    /^[A-Z]{2}[A-Z]{0,1}\d{1,2}[A-Z]{0,2}\d{4}$/,
    
    // BH Series: 22BH1234AA (2 digits + BH + 4 digits + 2 letters)
    /^\d{2}BH\d{4}[A-Z]{2}$/,
    
    // Commercial vehicles: DL12CA1234 (2 letters + 2 digits + 2 letters + 4 digits)
    /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/,
    
    // Legacy format: DL123AB4567 (2 letters + 3 digits + 2 letters + 4 digits)
    /^[A-Z]{2}\d{3,4}[A-Z]{2}\d{4}$/,
    
    // Electric vehicles: DL01EB1234 (2 letters + 2 digits + EB + 4 digits)
    /^[A-Z]{2}\d{2}EB\d{4}$/,
    
    // Defense vehicles: ARMY12345 (Word + 5 digits)
    /^(ARMY|NAVY|AIRFORCE|INDIANARMY)\d{5}$/,
    
    // Temporary registration: DL14T123456 (2 letters + 2 digits + T + 6 digits)
    /^[A-Z]{2}\d{2}T\d{6}$/,
    
    // Old format: DL8C1234 (2 letters + 1 letter + 4 digits)
    /^[A-Z]{2}[A-Z]\d{4}$/,
    
    // Chandigarh format: CH01AA1234 (2 letters + 2 digits + 2 letters + 4 digits)
    /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/,
  ];


    const vehicleNumber = formData.vehicle_number.toUpperCase();
    const isValid = patterns.some(pattern => pattern.test(vehicleNumber));

  if (!isValid) {
    alert(
      "Please enter a valid Indian registration number.\n\n" +
      "Examples:\n" +
      "• DL14CH2166 (Standard)\n" +
      "• 22BH1234AA (BH Series)\n" +
      "• DL01EB1234 (Electric)\n" +
      "• DL12CA1234 (Commercial)\n" +
      "• ARMY12345 (Defense)\n" +
      "• DL14T123456 (Temporary)"
    );
    return;
  }
  try {
    let response;
    if (vehicle && vehicle.id) {
      // Edit existing vehicle - use PUT
      response = await axios.put(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/${vehicle.id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } else {
      // Add new vehicle - use POST
      response = await axios.post(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    }

    if (response?.data) {
      setVehicleAdded(true);
    }

    onClose();
    toast.success(vehicle ? "Vehicle updated successfully!" : "Vehicle added successfully!");
    fetchVehicle();
  } catch (error) {
    console.error("Error saving vehicle:", error?.response?.data?.errors?.vehicle_number);
    toast.error("Failed to save vehicle");
  }
};


  return (
    <div className="customer-vehicle-info__modal-overlay">
      <div className="customer-vehicle-info__modal">
        <div className="customer-vehicle-info__modal-header">
          <h2 className="customer-vehicle-info__modal-title">
            {vehicle ? "Edit Vehicle" : "Add Vehicle"}
          </h2>
        </div>

        <div className="customer-vehicle-info__modal-content">
          <div className="customer-vehicle-info__form-row">
            <div className="customer-vehicle-info__form-group">
              <label className="customer-vehicle-info__label">Brand *</label>
              <select
                style={{ borderRadius: "20px" }}
                className="customer-vehicle-info__select"
                value={formData.brand}
                onChange={handleBrandChange}
              >
                <option value="">Select</option>
                {getBrands?.map((make: any) => (
                  <option key={make?.id} value={make?.id}>
                    {make?.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="customer-vehicle-info__form-group">
              <label className="customer-vehicle-info__label">Model *</label>
              <select
                style={{ borderRadius: "20px" }}
                className="customer-vehicle-info__select"
                value={formData.model}
                onChange={(e) =>
                  handleInputChange("model", Number(e.target.value))
                }
              >
                <option value="">Select</option>
                {(checkBrandId ? getModels : getAllModels)?.map((model) => (
                  <option key={model.id} value={model.id}>
                    {model.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="customer-vehicle-info__form-group">
              <label className="customer-vehicle-info__label">Year *</label>
              <select
                style={{ borderRadius: "20px" }}
                className="customer-vehicle-info__select"
                value={formData.make_year}
                onChange={(e) => handleInputChange("make_year", e.target.value)}
              >
                <option value="">Select</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="customer-vehicle-info__form-row">
            <div className="customer-vehicle-info__form-group">
              <label className="customer-vehicle-info__label">
                Fuel Type *
              </label>
              <select
                style={{ borderRadius: "20px" }}
                className="customer-vehicle-info__select"
                value={formData.fuel}
                onChange={(e) => handleInputChange("fuel", e.target.value)}
              >
                <option value="">Select</option>
                {getFuelType?.map((fuel: any) => (
                  <option key={fuel?.id} value={fuel?.id}>
                    {fuel?.type}
                  </option>
                ))}
              </select>
            </div>

            <div className="customer-vehicle-info__form-group">
              <label className="customer-vehicle-info__label">
                Vehicle Registration Number *
              </label>
              <input
                style={{ borderRadius: "20px" }}
                type="text"
                className="customer-vehicle-info__input"
                value={formData.vehicle_number}
                onChange={(e) =>
                  handleInputChange("vehicle_number", e.target.value)
                }
                placeholder="Enter Registration Number"
              />
            </div>
          </div>
        </div>

        <div className="customer-vehicle-info__modal-footer">
          <button
            className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--save"
            style={{
              borderRadius: "20px",
              background: "#ff6b35",
              color: "white",
            }}
            onClick={handleSave}
          >
            Save
          </button>
          <button
            className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--cancel"
            onClick={onClose}
            style={{ borderRadius: "20px" }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleEdit;
